import type { OptionTabGroup } from '@morpho-org/ui-v6/client'

import type { SectionConfig } from '@/hooks/useSectionScrollSpy'

export type VaultV2SubTabs =
  | 'overview'
  | 'allocation'
  | 'performance'
  | 'risk'
  | 'activity'
  | 'yourPosition'

export const VAULT_V2_SUB_TAB_OPTIONS: OptionTabGroup<VaultV2SubTabs>[] = [
  {
    label: 'Overview',
    value: 'overview'
  },
  {
    label: 'Allocation',
    value: 'allocation'
  },
  {
    label: 'Performance',
    value: 'performance'
  },
  {
    label: 'Risk',
    value: 'risk'
  },
  {
    label: 'Activity',
    value: 'activity'
  },
  {
    label: 'Your Position',
    value: 'yourPosition'
  }
]

export const VAULT_V2_SECTION_CONFIG: SectionConfig<VaultV2SubTabs>[] =
  VAULT_V2_SUB_TAB_OPTIONS.map(o => ({
    id: o.value,
    label: o.label,
    requiresConnectedWallet: o.value === 'yourPosition'
  }))
